export default {"src":"/_next/static/media/article-info.3e7d26e9.gif","height":1478,"width":2880,"blurWidth":0,"blurHeight":0};